import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, ResultFilterOptions } from '../../../appconfig/Settings';

import { getAllDetails, postAllData } from '../../../service/ProductService';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { CHANGE_REFRESHER_COURSE_CERTIFICATE_STATUS, GET_REFRESHER_COURSE_CANDIDATE_LIST } from '../../../config/ApiConstant';
import { RefresherCourseCertificationColumns } from '../../../appconfig/DatatableSetting';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { formatDateTime } from '../../../appconfig/AppHelper';
import Loader from '../../../components/Loadeer/Loader';
import { Badge } from 'primereact/badge';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { Tag } from 'primereact/tag';

export const ViewRefresherCourseCertification = () => {
    document.title = 'Online Refresher Course | GSPC';

    // Parameters
    const { courseId }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [bookedCandidatesList, setBookedCandidatesList] = useState<any>([]);
    const [bookedCourseList, setBookedCourseList] = useState<any>({});
    const [refresherCourseData, setRefresherCourseData] = useState<any>({});

    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [certiGenModal, setCertiGenModal] = useState<boolean>(false);
    const [certiGenLoader, setCertiGenLoader] = useState<boolean>(false);
    const [userId, setUserId] = useState<any>(null);

    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [selectedFeedback, setSelectedFeedback] = useState<any>(null);

    const [chartData, setChartData] = useState<any>({ slotData: {}, resultData: {}, compareData: {} });
    const [chartOptions, setChartOptions] = useState({});

    const formatValue = (val: any, fallback = '') => !window.cn(val) ? val : fallback;

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);

        // 1. Slot Availability Data (Doughnut)
        const slotData = {
            labels: [`Booked: ${bookedCourseList?.booked_slot}`, `Available: ${bookedCourseList?.available_slot}`],
            datasets: [{
                data: [bookedCourseList?.booked_slot || 0, bookedCourseList?.available_slot || 0],
                backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--orange-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--orange-400')],
                borderWidth: 1
            }]
        };

        // 2. Pass/Fail Data (Pie)
        const resultData = {
            labels: [`Pass: ${refresherCourseData?.total_pass}`, `Fail: ${refresherCourseData?.total_fail}`],
            datasets: [{
                data: [refresherCourseData?.total_pass || 0, refresherCourseData?.total_fail || 0],
                backgroundColor: [
                    '#22C55E', '#EF4444'
                ],
                hoverBackgroundColor: [
                    '#4ADE80', '#F87171'
                ],
                borderWidth: 1
            }]
        };

        // 3. Comparison Data (Bar)
        const compareData = {
            labels: [``],
            datasets: [{
                label: `Certificates: ${refresherCourseData?.total_certificate_generated}`,
                data: [refresherCourseData?.total_certificate_generated || 0],
                backgroundColor: [documentStyle.getPropertyValue('--purple-500')],
                borderWidth: 1
            }]
        };

        setChartData({ slotData, resultData, compareData });

        setChartOptions({
            plugins: { legend: { position: 'bottom' } },
            maintainAspectRatio: false,
            aspectRatio: 0.8
        });
    }, [bookedCourseList, refresherCourseData]);

    // useEffect
    useEffect(() => {
        getAllCandidateList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [appStatusFilter]);

    // Criteria
    const CriterionItem = ({ icon, label, value, color }: any) => (
        <div className="flex align-items-center justify-content-between py-2">
            <div className="flex align-items-center">
                <i className={`pi ${icon} mr-2`} style={{ color: color }}></i>
                <span className="text-700 font-medium">{label}</span>
            </div>
            <span className="text-900 font-bold">{value}</span>
        </div>
    );

    // Search by result status
    const searchByResultStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={ResultFilterOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Get all booked candidates list
    const getAllCandidateList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_REFRESHER_COURSE_CANDIDATE_LIST + '?refresher_course_id=' + atob(courseId) + '&result=' + appStatusFilter?.code);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setBookedCandidatesList([]);
                    setBookedCourseList({});
                    setRefresherCourseData({});
                } else {
                    setBookedCandidatesList(DataList?.list);
                    setBookedCourseList(DataList?.details);
                    setRefresherCourseData(DataList?.refresher_course_data
                    );
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setBookedCandidatesList([]);
                setBookedCourseList({});
                setRefresherCourseData({});
            }
        } catch (error: any) {
            setPageLoad(false);
            setBookedCandidatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Template for exam attended
    const examAttendedTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="text-center">{rowData.exam_attended === 1 ? <i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i> : <i className="fa-solid fa-circle-xmark" style={{ color: 'red' }}></i>}</div>
            </>
        );
    };

    // Template for certificate
    // const certificateTemplate = (rowData: any, rowIndex: any) => {
    //     return (
    //         <div className="text-center">
    //             {rowData.refresher_certy_status === 1 ? (
    //                 <a href={rowData.refresher_certy_link} target="_blank">
    //                     <i className="fa-solid fa-file-pdf fa-xl" style={{ color: 'red' }}></i>
    //                 </a>
    //             ) : (
    //                 '-'
    //             )}
    //         </div>
    //     );
    // };

    // Open change course Status modal
    const openCertiGenModal = (user_id: any) => {
        setUserId(user_id);
        setCertiGenModal(true);
    };

    // Close change course Status modal
    const closeCertiGenModal = () => {
        setUserId(null);
        setCertiGenLoader(false);
        setCertiGenModal(false);
    };

    // Generate certificate
    const generateCertificate = async () => {
        try {
            setCertiGenLoader(true);
            let formData: any = new FormData();
            formData.append('refresher_id', atob(courseId));
            formData.append('user_id', userId);

            const response = await postAllData(CHANGE_REFRESHER_COURSE_CERTIFICATE_STATUS, formData);
            if (response) {
                setCertiGenLoader(false);
                setCertiGenModal(false);
                setUserId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setTimeout(() => {
                    getAllCandidateList();
                }, 1500);
            } else {
                setCertiGenLoader(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setCertiGenLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for certificate status
    const certiStatusTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="text-center">
                    {!window.cn(rowData?.refresher_certy_link) ? <a href={rowData.refresher_certy_link} target="_blank">
                        <i className="fa-solid fa-file-pdf fa-xl" style={{ color: 'red' }}></i>
                    </a> : "-"}

                    {rowData?.result === "Pass" && (
                        <div className='mt-4'>
                            <InputSwitch onChange={(e) => openCertiGenModal(rowData.user_id)} />
                        </div>
                    )}

                    {/* <InputSwitch checked={rowData?.refresher_certy_status === 1 ? true : false} onChange={(e) => openCertiGenModal(rowData.user_id)} disabled={rowData.refresher_certy_status === 1 ? true : false} /> */}

                    {/* <div>{rowData.refresher_certy_status === 1 ? <Badge severity="success" value="Generated"></Badge> : <Badge severity="warning" value="Not Generated"></Badge>}</div> */}
                </div>
            </>
        );
    };

    // Reusable template for all lecture attendance fields
    const LecAttendTemplate = (rowData: any, field: string) => {

        const attended = rowData?.[field] === 1;
        const start_date = bookedCourseList?.start_date;
        const isOldEntry = new Date(start_date) < new Date("2025-11-20");


        // Default: show attendance status icons
        return (
            <div className="text-center">
                {
                    field !== "lec_8_attended" ? (
                        attended ?
                            <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                            :
                            <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                    ) : field === "lec_8_attended" ? (
                        !isOldEntry ? (
                            attended ?
                                <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                                :
                                <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                        ) : "-"
                    ) : <></>
                }
            </div>
        );
    };

    // Template for Summery
    const summaryTemplate = (rowData: any) => {
        return (
            !window.cn(rowData?.total_questions) ?
                <div className="result ml-4">
                    <h6 className='m-0 pb-1' style={{ borderBottom: "1px solid black", width: "100%", textAlign: "center", color: "green" }}>{rowData.corrected_answer}</h6>
                    <h6 className='m-0 pt-1' style={{ color: "green" }}>{rowData.total_questions}</h6>
                </div >
                : <div className="text-center">-</div>
        )
    }

    // feedbackModal Template
    const feedbackModalTemplate = (rowData: any) => {
        return (
            <div className="text-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-sm p-button-info"
                    onClick={() => {
                        setSelectedFeedback(rowData);
                        setFeedbackVisible(true);
                    }}
                />
            </div>
        );
    };

    // Helper function to render feedback details
    const renderFeedbackDetails = () => {
        if (!selectedFeedback || !selectedFeedback.feedback) {
            return <p>No feedback available.</p>;
        }

        let feedbackData;
        try {
            feedbackData = JSON.parse(selectedFeedback.feedback);
        } catch {
            return <p>Invalid feedback data.</p>;
        }

        const getEmoji = (value: string) => {
            if (!value) return "-";
            switch (value.toLowerCase()) {
                case "excellent": return "Excellent! 😄";
                case "good": return "Good 😊";
                case "can-be-improved": return "Can be Improved 😐";
                default: return value;
            }
        };

        return (
            <>
                <p><b>Satisfaction Level:</b> {getEmoji(feedbackData.satisfaction)}</p>
                <p><b>Quality of IT Platform:</b> {getEmoji(feedbackData.it_platform)}</p>
                <p><b>Quality of Speakers:</b> {getEmoji(feedbackData.speakers)}</p>
                <p><b>Suggestions:</b> {feedbackData.suggestions || "-"}</p>
            </>
        );
    };

    // Template for Result
    const resultTemplate = (rowData: any) => {
        return (
            <div className="text-center">{
                !window.cn(rowData?.result) ? rowData.result === "Pass" ? <Badge severity="success" value={"Pass"}>
                </Badge> : <Badge severity="danger" value={"Fail"}>
                </Badge> : "-"}
            </div>
        )
    }

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Online Refresher Course'} pageName={'Certification'} pageTitle={'Certification'} goToPage={true} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <div className="surface-ground border-round-xl">
                            {/* 1. Header Section: Identity & Dates */}
                            <div className="grid mb-4">
                                <div className="col-12">
                                    <Card className="shadow-1">
                                        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <div>
                                                <h2 className="text-900 font-bold mb-2 mt-0">
                                                    {formatValue(bookedCourseList?.refresher_course_name)}
                                                </h2>
                                                <span className="text-600 flex align-items-center">
                                                    <i className="pi pi-building mr-2"></i>
                                                    {formatValue(bookedCourseList?.college?.orgnameeng)}
                                                </span>
                                            </div>
                                            <div className="flex gap-4 mt-3 md:mt-0">
                                                <div className="text-center">
                                                    <span className="block text-500 font-medium mb-1">Start Date</span>
                                                    <span className="text-900 font-semibold">{formatValue(formatDateTime(bookedCourseList?.start_date), '--')}</span>
                                                </div>
                                                <Divider layout="vertical" className="hidden md:block" />
                                                <div className="text-center">
                                                    <span className="block text-500 font-medium mb-1">End Date</span>
                                                    <span className="text-900 font-semibold">{formatValue(formatDateTime(bookedCourseList?.end_date), '--')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>

                            {/* 2. Analytics Section: Charts */}
                            <div className="grid">
                                {/* Slot Capacity Chart */}
                                <div className="col-12 md:col-4">
                                    <Card title="Slot Status" className="shadow-2 h-full">
                                        <Chart type="doughnut" data={chartData.slotData} options={chartOptions} style={{ position: 'relative', height: '220px' }} />
                                        <div className="text-center mt-3 pt-3 border-top-1 border-300">
                                            <span className="text-600">Total Slots: </span>
                                            <span className="text-900 font-bold">{bookedCourseList?.total_slot}</span>
                                        </div>
                                    </Card>
                                </div>

                                {bookedCourseList?.status?.toLowerCase() === 'completed' && (
                                    <>
                                        {/* Pass/Fail Ratio Chart */}
                                        <div className="col-12 md:col-4">
                                            <Card title="Exam Results" className="shadow-2 h-full">
                                                <Chart type="pie" data={chartData.resultData} options={chartOptions} style={{ position: 'relative', height: '220px' }} />
                                                <div className="text-center mt-3 pt-3 border-top-1 border-300">
                                                    <span className="text-600">Total Exam Attended: </span>
                                                    <span className="text-900 font-bold">{refresherCourseData?.total_exam_attended}</span>
                                                </div>
                                            </Card>
                                        </div>

                                        {/* Certificates Chart */}
                                        <div className="col-12 md:col-4">
                                            <Card title="Certificates Issued" className="shadow-2 h-full">
                                                <Chart type="bar" data={chartData.compareData} options={chartOptions} style={{ position: 'relative', height: '220px' }} />
                                                <div className="text-center mt-3 pt-3 border-top-1 border-300">
                                                    <span className="text-600">Successfully Generated: </span>
                                                    <span className="text-900 font-bold">{refresherCourseData?.total_certificate_generated}</span>
                                                </div>
                                            </Card>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="grid">
                            {/* Before Condition */}
                            <div className="col-12 md:col-6">
                                <Card className="h-full border-1 border-300 shadow-none">
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="text-900 font-bold">Standard Phase</span>
                                        <Tag severity="info" value="Before 20 November 2025" />
                                    </div>
                                    <Divider />
                                    <CriterionItem icon="pi-users" label="Total Sessions" value="7" color="var(--blue-500)" />
                                    <CriterionItem icon="pi-percentage" label="Passing Marks" value="50%" color="var(--green-500)" />

                                    {/* Placeholder for missing attendance requirement in this phase */}
                                    <div className="py-2 text-400 italic font-italic text-sm">
                                        <i className="pi pi-minus-circle mr-2"></i> No Attendance Required
                                    </div>
                                </Card>
                            </div>

                            {/* After Condition */}
                            <div className="col-12 md:col-6">
                                <Card className="h-full border-blue-200 border-2 bg-blue-50 shadow-none">
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="text-900 font-bold">Updated Phase</span>
                                        <Tag severity="warning" value="After 20 November 2025" />
                                    </div>
                                    <Divider />
                                    <CriterionItem icon="pi-users" label="Total Sessions" value="8" color="var(--blue-500)" />
                                    <CriterionItem icon="pi-clock" label="Min. Attendance" value="75%" color="var(--orange-500)" />
                                    <CriterionItem icon="pi-percentage" label="Passing Marks" value="60%" color="var(--green-500)" />
                                </Card>
                            </div>
                        </div>
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={bookedCandidatesList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={bookedCandidatesList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Candidates Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {RefresherCourseCertificationColumns.map((col, i) => {
                                        if (col.field === 'SrNo') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'full_name') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'exam_attended') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={examAttendedTemplate} />;
                                        } else if (col.field === 'refresher_certy_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={certiStatusTemplate} />;
                                        } else if (col.field.startsWith('lec_') && col.field.endsWith('_attended')) {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    body={(rowData) => LecAttendTemplate(rowData, col.field)}
                                                />
                                            );
                                        }
                                        else if (col.field === 'result') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={resultTemplate} filter filterElement={searchByResultStatus} />;
                                        } else if (col.field === 'summary') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={summaryTemplate} />;
                                        }
                                        else if (col.field === 'feedback') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={feedbackModalTemplate} />;
                                        }
                                        // else if (col.field === 'certificate') {
                                        //     return <Column key={col.field} field={col.field} header={col.header} body={certificateTemplate} />;
                                        // } 
                                        else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RefresherCourseCertificationColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Certificate Generate Dialog */}
            <Dialog
                visible={certiGenModal}
                style={{ width: '450px' }}
                header="Generate Certificate"
                modal
                footer={
                    <>
                        <Button label="Cancel" className="p-button-secondary" onClick={closeCertiGenModal} />
                        <Button label="OK" className="p-button-success" onClick={() => generateCertificate()} loading={certiGenLoader} />
                    </>
                }
                onHide={closeCertiGenModal}
            >
                <div className="flex align-items-center justify-content-start">Are you sure you want to generate the certificate ?</div>
            </Dialog>
            {!pageLoad && <Loader />}

            {/* Feedback Details Dialog */}
            <Dialog
                visible={feedbackVisible}
                style={{ width: "500px" }}
                header="Feedback Details"
                modal
                onHide={() => setFeedbackVisible(false)}
            >
                {renderFeedbackDetails()}
            </Dialog>
        </>
    );
};
